import { Typography, TextField, Tooltip } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import "./gridControls.scss";
import { injectIntl } from "react-intl";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";

const ContainedLabel = ({
  tab,
  value,
  model,
  dd,
  onUpdate,
  width,
  intl = null,
  fullLangCode = "",
  fullWidth = false,
  disabled = false,
}) => {
  const [data, setData] = useState(injectIntlTranslation(intl, value, value));

  useEffect(() => {
    setData(injectIntlTranslation(intl, value, value));
  }, [fullLangCode]);

  const handleFieldChange = () => (event) => {
    // if (tab === "DrawingName") {
    //   setData(event.target.value.toLowerCase());
    // } else {
    setData(event.target.value);
    // }
  };

  const updateText = async (event) => {
    if (event.key === "Enter" && String(data).trim() !== "") {
      if (tab === "models") {
        onUpdate(data, model);
      } else if (tab === "DrawingName" || tab === "DD-Desc") {
        onUpdate(model, dd, data);
      }
    }
  };
  const onBlur = async (event) => {
    if (data && String(data).trim() !== "") {
      if (tab === "models") {
        onUpdate(data, model);
      } else if (tab === "DrawingName" || tab === "DD-Desc") {
        onUpdate(model, dd, data);
      }
    }
  };

  return (
    <div
      className="contained-grid-container contained-label"
      style={{ width: width }}
    >
      <Tooltip title={data || "\u00A0"} placement="right-start" arrow>
        <TextField
          size="small"
          className="contained-grid-label"
          id="outlined-basic"
          placeholder=""
          label=""
          value={data}
          onChange={handleFieldChange()}
          onKeyDown={updateText}
          onBlur={onBlur}
          style={
            fullWidth
              ? { width: "98%", pointerEvents: disabled ? "none" : "all" }
              : { pointerEvents: disabled ? "none" : "all" }
          }
        />
      </Tooltip>

      {tab === undefined && (
        <Typography className="contained-grid-label">
          {injectIntlTranslation(intl, data, data)}
        </Typography>
      )}
    </div>
  );
};

export default injectIntl(ContainedLabel);


// import { Typography,TextField,Tooltip } from "@material-ui/core";
// import React, {useEffect, useState} from "react";
// import './gridControls.scss';
// import { injectIntl } from "react-intl";
// import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";

// const ContainedLabel = ({tab, value, model,dd, onUpdate, width, intl=null, fullLangCode=""}) => {

//     const [data, setData] = useState(injectIntlTranslation(intl, value, value));

//     useEffect(() => {
//       setData(injectIntlTranslation(intl, value, value));
//       console.log(value, injectIntlTranslation(intl, value, value))
//     }, [fullLangCode]);

//   const handleFieldChange = () => (event) => {
//     if (tab === "DrawingName") {
//       setData(event.target.value.toLowerCase());
//     } else {
//       setData(event.target.value);
//     }
//   };

//   const updateText = async (event) => {
//     if (event.key === "Enter" && String(data).trim() !== "") {
//       if (tab === "models") {
//         onUpdate(data, model);
//       } else if (tab === "DrawingName" || tab === "DD-Desc") {
//         onUpdate(model, dd, data);
//       }
//     }
//   };
//   const onBlur = async (event) => {
//     if (data && String(data).trim() !== "") {
//       if (tab === "models") {
//         onUpdate(data, model);
//       } else if (tab === "DrawingName" || tab === "DD-Desc") {
//         onUpdate(model, dd, data);
//       }
//     }
//   };

//   return (
//     <div
//       className="contained-grid-container contained-label"
//       style={{ width: width }}
//     >
//       {tab !== undefined && data ? (
//         <Tooltip title={data || "\u00A0"} placement="right-start" arrow>
//           <TextField
//             size="small"
//             className="contained-grid-label"
//             id="outlined-basic"
//             placeholder=""
//             label=""
//             value={data}
//             onChange={handleFieldChange()}
//             onKeyDown={updateText}
//             onBlur={onBlur}
//           />
//         </Tooltip>
//       ) : (
//         <TextField
//           size="small"
//           className="contained-grid-label"
//           id="outlined-basic"
//           placeholder=""
//           label=""
//           value={data}
//           onChange={handleFieldChange()}
//           onKeyDown={updateText}
//           onBlur={onBlur}
//         />
//       )}
//       {tab === undefined && (
//         <Typography className="contained-grid-label">
//           {injectIntlTranslation(intl, data, data)}
//         </Typography>
//       )}
//     </div>
//   );
// };

// export default injectIntl(ContainedLabel);
